import { appendUrlArgs as appendUrlArguments } from '../../libs';
import { apiRequest } from '../../libs/ApiRequest/ApiRequest';
import {
  PostVacancyApplicationInitResponseInterface,
  PostVacancyApplicationSubmitRequestInterface,
  VacanciesResponseInterface,
  VacanciesSearchRequestInterface,
  VacancyDetailsResponseInterface,
} from '../../types/vacancies.types';
import { postUploadFile } from '../files';

export const fetchTopVacancies = async (
  abortController?: AbortController
): Promise<VacanciesResponseInterface | undefined> => {
  const vacancies = await apiRequest.get<VacanciesResponseInterface>(
    '/vacancies/top',
    abortController?.signal
  );
  return vacancies.parsedBody;
};

export const fetchSearchVacancies = async (
  requestParameters?: VacanciesSearchRequestInterface,
  abortController?: AbortController
): Promise<VacanciesResponseInterface | undefined> => {
  const vacancies = await apiRequest.get<VacanciesResponseInterface>(
    appendUrlArguments('/vacancies/search', requestParameters),
    abortController?.signal
  );

  return vacancies.parsedBody;
};

export const fetchVacancyDetails = async (
  reference?: string,
  abortController?: AbortController
): Promise<VacancyDetailsResponseInterface | undefined> => {
  if (!reference) throw new Error('Reference must be defined');
  const response = await apiRequest.get<VacancyDetailsResponseInterface>(
    `/vacancies/detail/${reference}`,
    abortController?.signal
  );

  return response.parsedBody;
};

export const postVacancyApplicationInit = async (
  abortController?: AbortController
): Promise<PostVacancyApplicationInitResponseInterface | undefined> => {
  const response = await apiRequest.post<object, PostVacancyApplicationInitResponseInterface>(
    `/vacancies/apply/init`,
    {},
    {},
    abortController?.signal
  );

  return response.parsedBody;
};

export const postVacancyApplicationSubmit = async (
  requestBody: PostVacancyApplicationSubmitRequestInterface,
  abortController?: AbortController
): Promise<object | undefined> => {
  return apiRequest.post<PostVacancyApplicationSubmitRequestInterface, object>(
    `/vacancies/apply/submit`,
    requestBody,
    {},
    abortController?.signal
  );
};

export const postVacancyApplication = async (
  requestBody: Omit<PostVacancyApplicationSubmitRequestInterface, 'containerId'>,
  file?: File,
  abortController?: AbortController
): Promise<object | undefined> => {
  if (!requestBody) throw new Error('requestBody must be defined');
  const initResponse = await postVacancyApplicationInit(abortController);
  if (initResponse?.containerId) {
    await postUploadFile(initResponse.containerId, file, abortController);
    return postVacancyApplicationSubmit(
      { ...requestBody, containerId: initResponse.containerId },
      abortController
    );
  }

  throw new Error('Failed to execute call');
};
